import { POST } from '@/api'
import { mergeWith, pick } from 'lodash'

const DETAIL = {
  customer: {
    syncMemberId: null,
    firstName: '',
    firstNameKana: '',
    lastName: '',
    lastNameKana: '',
    tel: '',
    mail: '',
  },
  date: null,
  time: null,
  number: 0,
  smoking: 0,
  courses: [],
  personalPermission: false,
  otherTxt: null,
}

/**
 * 予約詳細
 */
export default {
  namespaced: true,
  state: {
    detail: DETAIL,
    busy: false,
    error: null,
    complete: false,
  },
  mutations: {
    segment(state, segment) {
      state.segment = segment
    },
    set(state, detail) {
      state.detail = {
        ...DETAIL,
        ...detail,
        customer: { ...DETAIL.customer, ...detail.customer },
      }
    },
    update(state, detail) {
      state.detail = {
        ...state.detail,
        ...detail,
        customer: { ...state.detail.customer, ...detail.customer },
      }
    },
    updateCourse(state, { course, index }) {
      const courses = state.detail.courses.length ? state.detail.courses : [{}]
      courses[index] = { ...courses[index], ...course }
      state.detail = mergeWith({}, state.detail, { courses }, (o, s) => (Array.isArray(o) ? s : undefined))
    },
    busy(state, busy = false) {
      state.busy = busy
    },
    error(state, error) {
      state.error = error
    },
    complete(state, complete) {
      state.complete = complete
    },
    start(state) {
      state.error = null
      state.complete = false
    },
  },
  getters: {
    selectedCourse(state) {
      return state.detail.courses.length ? state.detail.courses[0] : {}
    },
  },
  actions: {
    async save({ commit, state, rootState }, lang) {
      commit('busy', true)

      const { customer, courses, personalPermission, otherTxt, ...reservation } = state.detail

      const { status, message, data } = await POST(`/${rootState.reception.segment}/api/web/reservation/regist`, {
        reservation: {
          ...reservation,
          courses: courses.map(o => pick(o, ['id', 'count'])).filter(o => o.id >= 0),
        },
        customer,
        personalPermission,
        lang,
        otherTxt,
      })
      if (status === 200) {
        commit('set', {})
        commit('complete', true)
      } else if (status === 409) {
        commit('error', message)
      } else {
        commit('error/message', message, { root: true })
      }

      commit('busy', false)
      return data.token
    },
  },
}
